import "fixed-header-table";

$(function () {
    $(".js-wmiList").fixedHeaderTable({
        footer: false,
        cloneHeadToFoot: false,
        fixedColumn: false,
        height: 600,
        width: "500px",
        themeClass: 'Table Table--default m-auto pb-2'
    });
});
